export default __webpack_public_path__ + "static/media/show more.1c7f59e7.PNG";